import { mapGetters } from 'vuex';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import * as elementsApi from '@motionelements/core/src/api/elements.js';
import notificationService from '@motionelements/core/src/services/notification.service.js';

export default {
  props: {
    elementId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      reason: '',
      details: '',
      //
      flags: [
        'ai_generated',
        'incorrect_tag',
        'inappropriate_content',
        'poor_quality',
        'other',
      ],
    };
  },
  validations() {
    const validations = {
      reason: {
        required,
      },
      details: {
        minLength: minLength(10),
        maxLength: maxLength(1000),
      },
    };
    if (this.reason === 'other') {
      validations.details.required = required;
    }
    return validations;
  },
  computed: {
    ...mapGetters({
      isAiGenerated: 'product/isAiGenerated',
    }),
    reasonText() {
      return (reason) => {
        switch (reason) {
          case 'ai_generated':
            return this.$t('flag_product.flag.ai_generated');
          case 'incorrect_tag':
            return this.$t('flag_product.flag.incorrect_tag');
          case 'inappropriate_content':
            return this.$t('flag_product.flag.inappropriate_content');
          case 'poor_quality':
            return this.$t('flag_product.flag.poor_quality');
          case 'other':
            return this.$t('flag_product.flag.other');
          // no default
        }
      };
    },
    payload() {
      const payload = { reason: this.reason };
      if (this.details) payload.details = this.details;
      return payload;
    },
    options() {
      const flags = _.clone(this.flags);
      if (this.isAiGenerated) {
        flags.splice(0, 1); // exclude "ai_generated"
      }
      return flags;
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        return elementsApi.flagProduct(this.elementId, this.payload)
          .then(() => {
            notificationService.alert({
              level: 'info',
              title: this.$t('flag_product.success_heading'),
            });
            this.hideModal();
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    hideModal() {
      this.$store.dispatch('modal/hide');
    },
    reset() {
      this.reason = '';
      this.details = '';
      this.$v.$reset();
    },
  },
};
